import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg ? e.msg : String(e))).join(" ");
  return String(detail);
}

export default api;
